/** *@name:mgVxeColgroup *@author:dingyongya *@date:2022/11/15 13:21 *@update:2022/11/15 13:21 */

<template>
  <vxe-colgroup :title="column.label" v-bind="column">
    <template v-for="item in column.children">
      <mg-vxe-colgroup
        v-if="item.children && item.children.length > 0"
        :key="item.prop"
        :column="item"
        :show-search-bar="showSearchBar"
        :header-search="headerSearch"
        :filter-method="filterMethod"
      >
        <template #headerInputCol="{ scoped }">
          <slot name="headerInputCol" v-bind:scoped="{ ...scoped, ...item }"></slot>
          <slot v-if="item.headerSlot" name="headerSlotCol" v-bind="item"></slot>
        </template>
        <template #headerSlotCol="item">
          <slot name="headerSlotCol" v-bind="item"></slot>
        </template>
        <template #default="{ scoped }">
          <slot v-bind:scoped="{ ...scoped, ...item }" />
        </template>
        <template #bodyContent="scoped">
          <slot name="bodyContent" v-bind="scoped"></slot>
        </template>
      </mg-vxe-colgroup>
      <template v-else>
        <mg-vxe-column
          v-if="item.slot&& !column.hidden"
          :column="item"
          :key="item.prop"
          :show-search-bar="showSearchBar"
          :header-search="headerSearch"
          :filter-method="filterMethod"
        >
          <template #headerInput="scoped">
            <slot name="headerInputCol" v-bind:scoped="{ scoped, item }"></slot>
            <slot name="headerSlotCol" v-bind="item"></slot>
          </template>
          <template v-if="item.slot" #default="scoped">
            <slot v-bind:scoped="{ ...scoped, item }"></slot>
          </template>
        </mg-vxe-column>
        <!-- 使用默认表格列渲染 -->
        <template v-else-if="item.default&& !column.hidden">
          <slot name="bodyContent" v-bind="item"></slot>
        </template>
        <!-- 常规数值显示的表格行 -->
        <mg-vxe-column
          v-else-if='!column.hidden'
          :column="item"
          :key="item.prop"
          :show-search-bar="showSearchBar"
          :header-search="headerSearch"
          :filter-method="filterMethod"
        >
          <template #headerInput="scoped">
            <slot name="headerInputCol" v-bind:scoped="{ scoped, item }"></slot>
            <slot name="headerSlotCol" v-bind="item"></slot>
          </template>
        </mg-vxe-column>
      </template>
    </template>
  </vxe-colgroup>
</template>

<script>
  import mgVxeColumn from './mgVxeColumn'
  export default {
    name: 'mgVxeColgroup',
    components: { mgVxeColumn },
    props: {
      column: {
        type: Object,
        default: () => {},
      },
      showSearchBar: Boolean,
      headerSearch: Boolean,
      filterMethod: Function,
    },
  }
</script>

<style scoped></style>
